export default __webpack_public_path__ + "static/media/side-profile-bridge.3163f2ae.jpg";